import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

//import { useSelector } from 'react-redux';
//import { RootStore } from 'bus/configureStore';
import {
  useChangeComingNomenclatureAdjustmentMutation,
  useCreateComingNomenclatureAdjustmentMutation,
  useLazyGetComingNomenclatureAdjustmentDetailQuery,
} from 'bus/comingNomenclatureAdjustment/services/info';
import { ComingNomenclatureAdjustmentItem } from 'bus/comingNomenclatureAdjustment/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: ComingNomenclatureAdjustmentItem = {
  id: null,
  comment: '',
  date: '',
  transportId: null,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ComingNomenclatureAdjustmentItem>(initialForm);

  const [getComingNomenclatureAdjustmentDetail] = useLazyGetComingNomenclatureAdjustmentDetailQuery();
  const [changeComingNomenclatureAdjustment, { isLoading: isLoadingChange }] =
    useChangeComingNomenclatureAdjustmentMutation();
  const [createComingNomenclatureAdjustment, { isLoading: isLoadingCrate }] =
    useCreateComingNomenclatureAdjustmentMutation();

  const storeTransport: any = useMemo(() => {
    const defaultFilter = ['transportType', '=', '2'];
    return $createDataSource('/v1/Transport', 'id', { defaultFilter });
  }, []);

  const onShown = async () => {
    if (id) {
      await getComingNomenclatureAdjustmentDetail({ id }).unwrap().then(setForm);
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeComingNomenclatureAdjustment(form);
      } else {
        const temp = { ...form };
        delete temp.id;
        await createComingNomenclatureAdjustment({ ...temp });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Корректировка"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, date: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Транспорт" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeTransport}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.transportId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, transportId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Транспорт" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Транспорт" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isLoadingCrate || isLoadingChange}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
